import { configureStore } from '@reduxjs/toolkit';
import { createWrapper, type MakeStore } from 'next-redux-wrapper';
import type { Store } from 'redux';
import thunkMiddleware from 'redux-thunk';
// Needed to make the type of store.dispatch() handle thunk actions
import type {} from 'redux-thunk/extend-redux';
import { isDebugMode } from '@/constants';
import type { FhhState } from '@/domain';
import { reducer } from './reducer';

// biome-ignore lint/suspicious/noExplicitAny: Not all redux is typescript yet
const makeStore: MakeStore<any> = ({ reduxWrapperMiddleware }) =>
    configureStore({
        reducer,
        middleware: (getDefaultMiddleware) => [...getDefaultMiddleware(), reduxWrapperMiddleware, thunkMiddleware],
    });

export const wrapper = createWrapper<Store<FhhState>>(makeStore, { debug: isDebugMode });
